import { TFunction } from "i18next";
import React from 'react';
import Helmet from "react-helmet";
import { withTranslation } from "react-i18next";

interface WithTitle<P> {
  component: React.ComponentType<P>;
  title: string;
}

interface Props {
  t: TFunction;
}

const withTitle = <P extends object>({ component: Component, title }: WithTitle<P>) => {
  class Title extends React.Component<P & Props, {}> {
    render() {
      const { t } = this.props;

      return (
        <>
          <Helmet
            defaultTitle={t("common:headTitles.defaultTitle")}
            titleTemplate={`%s | ${t("common:headTitles.defaultTitle")}`}
            title={t(`common:headTitles.${title}`)}
          />
          {/*// @ts-ignore*/}
          <Component {...this.props} />
        </>
      );
    }
  }

  return withTranslation()(Title);
};

export default withTitle;
